import {
    GET_BLOG_PAGE_THEME
} from '../middleware/types'

const initialState = {
    blogTheme : {}
}

export default (state = initialState, action) => {
    switch (action.type) {
        case GET_BLOG_PAGE_THEME:
            return {
                ...state,
                blogTheme : action.blogTheme
            }
        default:
            return state
    }
}